import React, { useEffect, useState, useCallback, Suspense } from "react";
import Button from "atoms/button";

import axios from "axios";
import { ApiContent } from "admin/pages/home/shaping";
const ApplicationProcess = React.lazy(() => import('molecules/applicationPopup'));

interface Entrepreneurs {
  image: string;
  title: string;
}

const JoinUs: React.FC = React.memo(() => {
  const [showPopup, setShowPopup] = useState(false);
  const [apiData, setApiData] = useState<Entrepreneurs[]>([]);
  const [apiContent, setApiContent] = useState<ApiContent | null>(null);

  // useCallback to avoid recreating handler
  const handleOpenPopup = useCallback(() => setShowPopup(true), []);
  const handleClosePopup = useCallback(() => setShowPopup(false), []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [entrepreneursRes, contentRes] = await Promise.all([
          axios.get(`${process.env.REACT_APP_LOCAL_URL}/api/enterprenurs`),
          axios.get(`${process.env.REACT_APP_LOCAL_URL}/api/content/68efbdc92d25c3fab303175f`),
        ]);

        if (entrepreneursRes.data.status === "success") {
          setApiData(entrepreneursRes.data.message || []);
        }
        if (contentRes.data.status === "success") {
          setApiContent(contentRes.data.data || null);
        }
      } catch (error) {
        console.error("Error fetching join us data:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <section className="gsap-fade-in w-container blade-bottom-padding-lg">
      <h2 className="text-36 font-lato-bold mt-9 xl:mt-16 text-[#07393C]">
        {apiContent?.heading}
      </h2>

      <div className="mt-6 grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-3 gap-14 !w-full">
        {apiData.map((elem, index) => {
          // compute image URL once
          const imageUrl = `${process.env.REACT_APP_LOCAL_URL}/${elem.image.replace(/\\/g, "/")}`;

          return (
            <div
              className="flex gap-5 w-full items-center sm:w-3/4 lg:w-full"
              key={elem.title + index} // better than just index
            >
              <div className="shrink-0">
                <img
                  src={imageUrl}
                  alt={elem.title || "mentor Development Entrepreneurs"}
                  className=""
                  loading="lazy" // defer non-critical images
                
                />
              </div>
              <h4 className="font-lato-regular">{elem.title}</h4>
            </div>
          );
        })}
      </div>

      <div className="blade-top-margin h-10 w-52 md:blade-top-margin-sm md:h-14 md:w-60">
        <div onClick={handleOpenPopup} className="cursor-pointer">
          <Button text={"Join us"} />
        </div>

               {showPopup && (
          <Suspense fallback={<div className="text-center py-10">Loading...</div>}>
            <ApplicationProcess onclose={handleClosePopup} />
          </Suspense>
        )}

      </div>
    </section>
  );
});

export default JoinUs;
